import inspect from 'onyx-common/inspect'

const logInspect = val => {
  const str = inspect(val, true)
  console.log(str)
}

export default logInspect
